import { useMemo } from 'react';

interface UseInputAccessibilityProps {
  id?: string;
  label?: string;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
}

export const useInputAccessibility = ({
  id,
  label,
  errorMessage,
  required,
  disabled
}: UseInputAccessibilityProps) => {
  const generatedId = useMemo(() => id || `input-${Math.random().toString(36).substr(2, 9)}`, [id]);
  const errorId = `${generatedId}-error`;

  const accessibilityProps = {
    id: generatedId,
    'aria-required': required,
    'aria-invalid': !!errorMessage,
    'aria-describedby': errorMessage ? errorId : undefined,
    'aria-disabled': disabled,
  };

  return {
    inputId: generatedId,
    errorId,
    accessibilityProps
  };
};
